import React from 'react'
import styled from 'styled-components'
import stairsImg from './stairs.png'

const Wrapper = styled.div`
  color: #383838;
  font-weight: bold;
  font-size: 3.5rem;
  margin-right: 3rem;

  img {
    height: 4rem;
    margin-right: 1.3rem;
  }
`

interface IProps {
  floor: string
}

const Floor = ({ floor }: IProps) => (
  <Wrapper>
    <img src={stairsImg} alt="stairs"/>
    {floor}
  </Wrapper>
)

export default Floor
